import {Component, Input, OnInit} from '@angular/core';
import {split} from 'lodash-es';

@Component({
    selector: 'avatar-component',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements OnInit {
    @Input() name: string;
    constructor(
    ) {
    }

    get initials(): string {
        return split(this.name, ' ').map(part => part.charAt(0).toUpperCase()).join('');
    }

    get color(): string {
        return this.name.charAt(0).toUpperCase();
    }


    ngOnInit(): void {
    }

    avatarStyle(): string {
        return 'background-color:' + this.nameToColour();
    }

    nameToColour(): string
    {
        let hash = 0;
        this.name.split('').forEach((char) => {
            // eslint-disable-next-line no-bitwise
            hash = char.charCodeAt(0) + ((hash << 5) - hash);
        });
        let color = '';
        for (let i = 0; i < 3; i++) {
            // eslint-disable-next-line no-bitwise
            const value = (hash >> (i * 8)) & 0xff;
            color += value.toString(16).padStart(2, '0');
        }
        return '#' + this.lighten(color, 20);
    }

    lighten(color: string, percent: number): string {
        const num = parseInt(color, 16);
        const amt = Math.round(2.55 * percent);
        // eslint-disable-next-line no-bitwise
        const R = (num >> 16) + amt;
        // eslint-disable-next-line no-bitwise
        const B = (num >> 8 & 0x00FF) + amt;
        // eslint-disable-next-line no-bitwise
        const G = (num & 0x0000FF) + amt;

        return (0x1000000 + (R<255?R<1?0:R:255)*0x10000 + (B<255?B<1?0:B:255)*0x100 + (G<255?G<1?0:G:255)).toString(16).slice(1);
    };

}
